import { HelpCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { useMemo } from "react";
import { Show } from "shared/components";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";
import { Money } from "shared/types";
import { cx, toMoney } from "shared/utils";

export const KeyValue = ({
  label,
  value,
  flagEmpty = false,
  flagTooltip,
  gapClassName = "gap-1"
}: {
  label: string;
  value: string | number | Money | React.ReactNode;
  flagEmpty?: boolean;
  flagTooltip?: string;
  gapClassName?: string;
}) => {
  // eslint-disable-next-line sonarjs/function-return-type -- linter, chill - that's fine and expected
  const normalizedValue = useMemo(() => {
    if (flagEmpty && !value)
      return (
        <Tooltip>
          <TooltipTrigger>
            <HugeiconsIcon
              icon={HelpCircleIcon}
              className="size-4 shrink-0 text-warning-500"
            />
          </TooltipTrigger>
          <Show if={flagTooltip}>
            <TooltipContent className="bg-alpha-800 rounded-lg border p-4 text-sm text-white">
              {flagTooltip}
            </TooltipContent>
          </Show>
        </Tooltip>
      );

    return value && typeof value === "object" && "cents" in value
      ? toMoney(value.cents / 100)
      : value || "-";
  }, [value, flagEmpty, flagTooltip]);

  return (
    <div className={cx("flex text-sm font-medium", gapClassName)}>
      <span className="text-content-300 max-w-[180px] w-full">{label}</span>
      <span className="text-content-1000">{normalizedValue}</span>
    </div>
  );
};
